import { RightArrowIcon, DotIcon, DownArrowIcon } from "../../utils/icon.utils";
import { NavLink } from "react-router-dom";
import useScreenSize from "../../hooks/useScreenSize";
import { useHasPermission } from "../../utils/route.utils";
import { arrayMap } from "../../utils/array.utils";

const NavItem = ({
  data,
  setOpenIndex,
  openIndex,
  index,
  activeIndex,
  setActiveIndex,
  collapse,
  collapseToggle
}) => {
  const { displayNone } = useHasPermission();
  const { isLg } = useScreenSize();

  const toggleItem = (clickedIndex) => {
    setOpenIndex((prevIndex) => (prevIndex === clickedIndex ? null : clickedIndex));
    setActiveIndex(clickedIndex);
  };

  const ParentIcon = data?.icon;
  const isOpen = openIndex === index;
  const isActiveIndex = activeIndex === index;
  const hasChildren = !!data?.children?.length;

  const ToggleIcon = isOpen ? DownArrowIcon : RightArrowIcon;

  const navLinkClass = "nav-link d-flex align-items-center justify-content-between w-100 rounded";

  const itemToggleHandler = (toggleIndex) => {
    toggleItem(toggleIndex);
    if (!hasChildren && !isLg) {
      collapseToggle();
    }
  };

  return (
    <li className={`nav-item d-flex flex-column mb-1 ${displayNone(data?.permissions)}`}>
      <NavLink
        className={({ isActive }) =>
          isActive && isActiveIndex ? "active " + navLinkClass : navLinkClass
        }
        to={hasChildren ? undefined : data?.route}
        onClick={() => itemToggleHandler(index)}>
        <span className="d-flex align-items-center">
          {ParentIcon && <ParentIcon style={{ fontSize: "1rem" }} />}
          {!collapse && <span className="ms-3">{data?.name}</span>}
        </span>
        {hasChildren && !collapse && <ToggleIcon />}
      </NavLink>
      {isOpen && !collapse && (
        <ul className="nav flex-column g-3">
          {arrayMap(data?.children, (childItem, childIndex) => (
            <li
              key={childIndex + 1}
              className={`nav-item d-flex align-items-center ps-4 mt-1 ${displayNone(data?.permissions)}`}>
              <NavLink
                className={({ isActive }) =>
                  isActive && isOpen ? "active " + navLinkClass : navLinkClass
                }
                to={childItem?.route}
                onClick={() => !isLg && collapseToggle()}>
                <span className="d-flex align-items-center">
                  <DotIcon style={{ fontSize: "0.4rem" }} />
                  <span className="ms-3">{childItem?.name}</span>
                </span>
              </NavLink>
            </li>
          ))}
        </ul>
      )}
    </li>
  );
};

export default NavItem;
